/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import {
	View,
	TextField,
	ActionButton,
	Text,
	Pressable,
	ErrorText,
	Checkbox,
} from '@components/atoms'

import { User } from '@utils'

interface PropsType {
	label?: string
	errorMessage?: string
	isResetPassword?: boolean
	onChange?: (value: string) => void
	variant?: 'filled' | 'outlined' | 'standard'
}

export const ResetPasswordTextField = (props: PropsType) => {
	const { label, errorMessage, isResetPassword, onChange, variant } = props

	const [password, setPassword] = React.useState<string>('')
	const [isRandomPassword, setIsRandomPassword] = React.useState<boolean>(true)
	const [passwordType, setPasswordType] = React.useState<string>('password')

	const isError: boolean = errorMessage !== undefined && errorMessage !== ''

	React.useEffect(() => {
		if (isResetPassword) {
			getRandomPassword()
			setIsRandomPassword(true)
		}
	}, [isResetPassword])

	React.useEffect(() => {
		if (isRandomPassword) {
			getRandomPassword()
		}
	}, [isRandomPassword])

	React.useEffect(() => {
		if (onChange) {
			onChange(password)
		}
	}, [password])

	const getRandomPassword = React.useCallback(() => {
		const newPassword: string = User.getRandomPassword()
		setPassword(newPassword)
	}, [password])

	const onManualPasswordChange = React.useCallback((e: any) => {
		const str = e.target.value
		setPassword(str)
	}, [])

	const onRandonPasswordCheckboxClick = React.useCallback(() => {
		setPassword('')
		setIsRandomPassword(!isRandomPassword)
	}, [isRandomPassword])

	const onShowPassword = () => {
		const newType = passwordType === 'password' ? 'default' : 'password'
		setPasswordType(newType)
	}

	return (
		<View css={style}>
			{isRandomPassword ? (
				<View className="textFieldView">
					<TextField
						className="columnTextField"
						size="small"
						label={label ?? ''}
						value={password}
						error={isError}
						variant={variant ?? 'outlined'}
					/>
					<View className="rightAccessoryView">
						<ActionButton
							className="showPasswordButton"
							iconName="reload"
							title="새로 생성"
							onClick={getRandomPassword}
						/>
					</View>
				</View>
			) : (
				<View className="textFieldView">
					<TextField
						label="패스워드"
						size="small"
						type={passwordType}
						value={password}
						onChange={onManualPasswordChange}
						variant={variant ?? 'outlined'}
					/>
					<View className="rightAccessoryView">
						<ActionButton
							className="showPasswordButton"
							title={passwordType === 'password' ? '보기' : '가리기'}
							iconName={passwordType === 'password' ? 'eye' : 'eye-off'}
							onClick={onShowPassword}
						/>
					</View>
				</View>
			)}

			<View className="randomPasswordYnView">
				<Pressable css={{ display: 'flex' }} onClick={onRandonPasswordCheckboxClick}>
					<Text category="p1" className="randomPasswordYnTitle">
						랜덤 패스워드
					</Text>
					<Checkbox checked={isRandomPassword} />
				</Pressable>
			</View>

			{isError && (
				<View>
					<ErrorText className="errorMessage">{errorMessage}</ErrorText>
				</View>
			)}
		</View>
	)
}

const style = css({
	width: '100%',

	'.textFieldView': {
		position: 'relative',
		width: '100%',

		'.columnTextField': {
			width: '100%',
		},

		'.rightAccessoryView': {
			position: 'absolute',
			top: '0rem',
			right: '0.2rem',

			'.showPasswordButton': {
				width: 'fit-content',
				height: 'fit-content',
			},
		},
	},
})
